<script lang="ts">
  import Icon from "@iconify/svelte";

  import { onMount } from "svelte";

  export let accountName: string = "onGRID";
  export let pageTitle: string = "";
  export let pageIcon: string | undefined = undefined;
  export let isPublic: boolean = false;
</script>

<div class="flex-shrink-0 h-16 print:hidden bg-pbg-600">
  <div class="flex flex-row items-center justify-between h-full font-normal text-textpbg-500">
    <div class="flex flex-row flex-grow h-full gap-4">
      <div
        class="menu flex flex-col justify-center p-4 md:pl-6 md:pr-6 w-56 2xl:w-56 shadow-md pbg-500"
      >
        <div class="text-lg leading-5 font-extralight flex items-center">
          {#if $$slots.logo}
            <slot name="logo" />
          {:else}
            {accountName}
          {/if}
        </div>
      </div>

      <div class=" gap-4 items-center hidden md:flex">
        {#if pageIcon}
          <div class="hidden xl:block">
            <Icon icon={pageIcon} class="w-7 h-7 text-textpbg-900" />
          </div>
        {/if}
        <div
          class="flex items-center font-extralight text-textpbg-200 text-sm xl:text-[0.98rem]"
        >
          {pageTitle}
        </div>
      </div>
    </div>
    <div class="flex items-center h-full gap-3 p-2 md:p-6">
      {#if $$slots.actions}
        <slot name="actions" />
      {/if}

      {#if !isPublic}
        {#if $$slots.profile}
          <slot name="profile" />
        {/if}
      {/if}
    </div>
  </div>
</div>
